module.exports = __webpack_public_path__ + "img/bg.384a6356.png";